import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import WordMark from '../../assets/images/logos/word_mark_logo.webp';
import PolicyContent from './home/Function';
import { orbitUsageRulesContext } from './home/OrbitUsageRulesContext';

export const OrbitUsageRules = () => {
	const useStyles = makeStyles({
		box: {
			backgroundColor: 'white',
			color: 'black',
		},
	});
	const classes = useStyles();

	return (
		<Box>
			<Box className={classes.box} sx={{ pl: { xs: 0, sm: 12 }, pt: 4, pb: 3, mt: 0.5, margin: { xs: 0, lg: 'auto' }, mb: 0.3, width: { xs: '100%', lg: '80%' } }}>
				<Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
					<img src={WordMark} alt="POFSIS Logo" width={200} style={{ maxWidth: '80%' }} />
				</Box>
			</Box>
			<Box className={classes.box} sx={{ px: { xs: 3, sm: 12 }, pt: 6, pb: 4, margin: 'auto' }}>
				<PolicyContent data={orbitUsageRulesContext()} index={0} />
			</Box>
		</Box>
	);
};
